export const UPLOAD_ERRORS_BACK_BUTTON_COPY = 'Back to all uploads';
export const UPLOAD_ERRORS_FOUND_INFO_POSTFIX_COPY =
  'found, export the error file for further information';
export const UPLOAD_ERRORS_DOWNLOAD_BUTTON_COPY = 'Download errors file';
